<script>
export default {
    name: "RequestItemForm",
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum>
            <li>Loan Items - Request Items</li>
        </template>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                  <h5 class="text-sm font-bold">Make Item Request</h5>
              </template>
              <template v-slot:card-body>
                  <div class="flex flex-wrap">
                      <div class="md:w-1/3 sm:w-full p-1">
                          <label for="grid-item" class="label-control">Item:</label>
                          <v-select class="text-xs bg-white"></v-select>
                      </div>
                      <div class="md:w-1/6 sm:w-full p-1">
                          <label for="grid-qty" class="label-control">Qty:</label>
                          <input type="number" id="grid-qty" class="input-control input-sm text-xs text-right">
                      </div>
                      <div class="md:w-1/3 sm:w-full p-1">
                          <label for="grid-description" class="label-control">Description:</label>
                          <textarea id="grid-description" cols="30" rows="2" class="input-sm input-control text-xs"></textarea>
                      </div>
                  </div>
              </template>
              <template v-slot:card-footer>
                  <div class="flex justify-end">
                      <router-link :to="{ name: `loan-items.request-items.index`}" class="btn-sm btn-danger text-xs mr-6">Back</router-link>
                      <button class="btn-sm btn-primary text-xs"><i class="fa fa-save"></i> Save</button>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>